import { extendTheme } from "@chakra-ui/react";
import "@fontsource/roboto/400.css";

import JsonStyle from '../../static/G1Style.json' ;
import JsonColors from '../../static/G1Colors.json' ;

import { ErrorField } from "@/style/ErrorField";
import { FormControl } from "@/style/FormControl";
import { FormLabel } from "@/style/FormLabel";
import { G1Style } from "@/theme/G1Style";

G1Style.loadJSON(JsonStyle, JsonColors) ;

const theme = extendTheme({
    config: {
        initialColorMode: "system",
        useSystemColorMode: true,
    },
    components: {
        FormLabel: FormLabel,
        FormControl: FormControl,
        ErrorField: ErrorField,
        Button: { 
            baseStyle: { 
                fontWeight: "500", 
                borderRadius: "10px"
            }
        }
    },
    fonts: {
        heading: "'DM Serif Display', Georgia, serif",
        body: "roboto",
    },
    colors: {
        ...JsonColors,
        brand: {
            50: "#f0f4ff", 100: "#dce6ff", 500: "#3354f4",
            600: "#2441d9", 700: "#1a30b0", 900: "#0d1a5c",
        },
        surface: { base: "#F7EBE8", card: "#ffffff", subtle: "#f1f4fb" },
    },
    styles: {
        global: (props) => ({
            html: {
                bg: props.colorMode === "dark" ? "black" : "white",
                height: "100vh",
                overflow: "auto",
            },
            body: {
                bg: props.colorMode === "dark" ? "black" : "white",
                overflow: "hidden",
                // override responsive pour l'ensemble des textes définis comme des paragraphes
                p: {
                    // xs, sm , md, lg, xl
                    fontSize: ["0.75rem", "0.875rem", "1rem", "1.125rem", "1.25rem"],
                },
                h3: {
                    // xs, sm , md, lg, xl
                    fontSize: ["1.35rem", "1.475rem", "1.6rem", "1.725rem", "1.85rem"],
                },
                h1: {
                    // xs, sm , md, lg, xl
                    fontSize: ["2.25rem", "2.375rem", "2.4rem", "2.525rem", "2.65rem"],
                },
            },
        }),
    },
});

export default theme;